module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[103]224.82e82df.woff2";